import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router  } from '@angular/router';
import { LowerCasePipe, DecimalPipe } from '@angular/common';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

// Providers
import { ClientesService } from '../../../services/Clientes.service';
import { RutasService } from '../../../services/rutas.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
// Helpers
import { AlertasModales } from '../../../helpers/alertasModales';
import { Helper } from '../../../helpers/helper';
import { Date2Pipe } from '../../../pipes/date2.pipe';
import { ConfiguracionesService } from '../../../services/configuraciones.service';

const ID_PAGINA = 6;

@Component({
  selector: 'app-notas',
  templateUrl: './notas.component.html',
  styleUrls: ['./notas.component.css']
})
export class NotasComponent implements OnInit {
  notas = [];
  rutas = [];
  empleados = [];
  page = 1;
  limit = '25';
  offset = 0;
  size = 0;
  loaded = false;
  loading = false;
  multiSelectPrestamos: any;
  rutasSeleccionadas = [];
  empleadoSeleccionado = '';
  ce = '';
  fecha_desde: NgbDateStruct;
  fecha_hasta: NgbDateStruct;
  distancia = 1;
  operador = '1';
  columnsSort = [];
  private columnsServer = [];
  exportando = false;
  configPdf: any;

  constructor(
    private clienteService: ClientesService,
    private rutaService: RutasService,
    private route: ActivatedRoute,
    private router: Router,
    private helper: Helper,
    private modals: AlertasModales,
    public empleadoService: EmpleadosServicio,
    private configuracionService: ConfiguracionesService,) {

    if (empleadoService.datosEmpleado.tipo_empleado !== 3 && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    if ( localStorage.getItem('rutasSeleccionadas')) {
      this.rutasSeleccionadas = JSON.parse(localStorage.getItem('rutasSeleccionadas'));
    }

    this.initColumns();
    this.initRutas();
    this.initEmpleados();
    this.initConfigPdf();
  }

  ngOnInit() {
    this.initConfigMultiSelect();
    this.verificarQueryString();
  }

  private initNotas(): void {
    this.loading = true;
    let fecha_desde = '';
    let fecha_hasta = '';
    if (this.fecha_desde) {
      fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }

    if (this.fecha_hasta) {
      fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }

    this.clienteService.obtenerNotasClientes(
      this.limit,
      this.offset,
      this.rutasSeleccionadas.map(data => data.id).join(),
      this.ce,
      this.empleadoSeleccionado,
      fecha_desde,
      fecha_hasta,
      this.operador,
      this.distancia,
      JSON.stringify(this.columnsServer))
    .subscribe((res: any) => {
      this.notas = res.notas;
      this.size = res.total_items;
      setTimeout(() => {
        this.loaded = true;
        this.loading = false;
      }, 1);
    });
  }

  private initConfigMultiSelect() {
    this.multiSelectPrestamos = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit: 3,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas()
    .subscribe(res => {
      for (const ruta of res.rutas) {
        this.rutas.push({
          id: ruta.ID_RUTA,
          itemName: String(ruta.nombre)
        });
      }
    });
  }

  filtrarNotas() {
    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['cliente'] = this.ce;
    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      queryParams['rutas'] = rutas;
    } else {
      delete queryParams['rutas'];
    }
    if (
      this.fecha_desde !== undefined &&
      this.fecha_desde !== null &&
      this.fecha_desde.year !== null
    ) {
      queryParams['fecha_inicia'] = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
    }
  
    if (
      this.fecha_hasta !== undefined &&
      this.fecha_hasta !== null &&
      this.fecha_hasta.year !== null
    ) {
      queryParams['fecha_termina'] = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
    }
  
    queryParams['operador'] = this.operador;
    queryParams['distancia'] = this.distancia;
    queryParams['empleado'] = this.empleadoSeleccionado;
    queryParams['limite'] = this.limit;
    this.router.navigate(['./lista/notas'], { queryParams: queryParams });
  }

  notaMapa(nota) {
    if (nota.lat !== 0 && nota.lng !== 0) {

      const markers = [
        {
          lat: nota.lat,
          lng: nota.lng,
          comentario: nota.comentario,
          empleado: nota.empleado,
          tipo: 2,
          iconUrl: '../../../../../assets/img/comment-marker.png'
        }
      ];
      const lowerCasePipe = new LowerCasePipe();
      this.modals.vistaMapaNgbModal(markers, `Nota de ${lowerCasePipe.transform(nota.cliente)}`);
    }
  }

  private initEmpleados(): void {
    this.empleadoService.listaEmpleado()
    .subscribe(res => this.empleados = res.empleados);
  }

  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {

        if (params.fecha_inicia) {
          const yearInit = parseFloat(params.fecha_inicia.split('-')[0]);
          const monthInit = parseFloat(params.fecha_inicia.split('-')[1]);
          const dayInit = parseFloat(params.fecha_inicia.split('-')[2]);

          if ( !isNaN( yearInit ) && !isNaN( monthInit ) && !isNaN( dayInit ) ) {
            this.fecha_desde = { year: yearInit, month: monthInit, day: dayInit };
          }
        }

        if (params.fecha_termina) {
          const yearEnd = parseFloat(params.fecha_termina.split('-')[0]);
          const monthEnd = parseFloat(params.fecha_termina.split('-')[1]);
          const dayEnd = parseFloat(params.fecha_termina.split('-')[2]);

          if ( !isNaN( yearEnd ) && !isNaN( monthEnd ) && !isNaN( dayEnd ) ) {
            this.fecha_hasta = { year: yearEnd, month: monthEnd, day: dayEnd };
          }
        }

        if (params.hasOwnProperty('cliente')) {
          this.ce = params.cliente;
        }

        if (params.hasOwnProperty('operador') && !isNaN(params.operador)) {
          this.operador = params.operador;
        }
        if (params.hasOwnProperty('distancia') && !isNaN(params.distancia)) {
          this.distancia = params.distancia;
        }
        if (params.hasOwnProperty('empleado') && !isNaN(params.empleado)) {
          this.empleadoSeleccionado = params.empleado;
        }
        if (params.hasOwnProperty('limite')) {
          this.limit = params.limite;
        }
        if (params.hasOwnProperty('page') && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = parseFloat(this.limit) * (this.page - 1);
        }
        this.columnsServer = [];
        // tslint:disable-next-line:forin
        for (const columnParams in params) {
          for (const column of this.columnsSort) {
            if (column.label.replace(/\s/g, '').toLowerCase() === columnParams.replace('order', '')) {
              if (params[columnParams].toLowerCase() === 'asc' || params[columnParams].toLowerCase() === 'desc') {
                column.order = params[columnParams].toLowerCase();
                this.columnsServer.push(column);
                break;
              }
            }
          }
        }
        this.initNotas();
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.offset = parseFloat(this.limit) * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./lista/notas'], { queryParams: queryParams });
  }

  orderTable(column) {
    if (!column.order) {
      column.order = 'desc';
    } else {
      column.order = column.order === 'desc' ? 'asc' : 'desc';
    }
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`];
    queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`] = column.order;
    this.router.navigate(['./lista/notas'], { queryParams: queryParams });
  }

  private initColumns(): void {
    this.columnsSort = [
      {
        label: 'Cliente',
        column: 'cliente',
        order: ''
      },
      {
        label: 'Comentario',
        column: 'comentario',
        order: ''
      },
      {
        label: 'Zona',
        column: 'ruta',
        order: ''
      },
      {
        label: 'Empleado',
        column: 'empleado',
        order: ''
      },
      {
        label: 'Fecha',
        column: 'n.fecha_registro',
        order: ''
      },
      {
        label: 'Distancia',
        column: 'distancia',
        order: ''
      }
    ];
  }

  exportar(downOpen = true) {
    if (this.empleadoService.permisosAsignados.filter(a => a.ID_PERMISO == 1).length || this.empleadoService.datosEmpleado.tipo_empleado === 3) {
      if (!this.exportando && this.notas.length > 0) {
        this.exportando = true;
        const rows = [];
        const columns = [
          {title: 'Cliente', dataKey: 0},
          {title: 'Comentario', dataKey: 1},
          {title: 'Zona', dataKey: 2},
          {title: 'Empleado', dataKey: 3},
          {title: 'Fecha', dataKey: 4},
          {title: 'Distancia', dataKey: 5}
        ];

        let fecha_desde = '';
        let fecha_hasta = '';
        if (this.fecha_desde) {
          fecha_desde = `${this.fecha_desde.year}-${this.fecha_desde.month}-${this.fecha_desde.day}`;
        }
    
        if (this.fecha_hasta) {
          fecha_hasta = `${this.fecha_hasta.year}-${this.fecha_hasta.month}-${this.fecha_hasta.day}`;
        }
        let fecha = '';

        this.clienteService.obtenerNotasClientes(
          0, 0,
          this.rutasSeleccionadas.map(data => data.id).join(),
          this.ce,
          this.empleadoSeleccionado,
          fecha_desde,
          fecha_hasta,
          this.operador,
          this.distancia,
          JSON.stringify(this.columnsServer))
          .subscribe( (res: any) => {

          for (const row of res.notas) {
            rows.push({
              0: row.cliente,
              1: row.comentario,
              2: row.ruta,
              3: row.empleado,
              4: new Date2Pipe().transform(row.fecha_registro, 'dd-MM-yyyy'),
              5: new DecimalPipe('en-US').transform(row.distancia) + ' km(s)',
            });
          }

          const columnStyles = {
            0: {columnWidth: 100},
            1: {columnWidth: 250},
          };

          this.helper.exportarReportePdf(this.configPdf,
            'Notas',
            columns,
            rows,
            this.empleadoService.datosEmpleado.usuario,
            columnStyles,
            'p',
            downOpen)
          .then(() => {
            this.exportando = false;
          })
          .catch(() => {
            this.exportando = false;
          });
        });
      }
    } else {
      this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
      'red',
      'modern',
      false,
      'fa fa-thumbs-down');
    }
  }

  private initConfigPdf(): void {
    this.configuracionService.obtenerConfiguraciones()
    .subscribe((res: any) => {
      this.configPdf = {
        direccion: res.direccion_recibo,
        tel: res.telefono_recibo,
        nombre_compania: res.descripcion,
        rnc_compania: res.rnc,
        fax_compania: res.fax,
        email_compania: res.email,
        ciudad_compania: res.ciudad,
        tel_compania: res.telefono,
        direccion_compania: res.dirección
      };
    });
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/clientes/notas/notas.component.ts